import ztComponent from './ztSwitch.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
